import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-select-slot',
  templateUrl: './select-slot.component.html',
  styleUrls: ['./select-slot.component.scss']
})
export class SelectSlotComponent implements OnInit {

  @Input() public cpxCards: Array<string>;
  @Output() public selectCard = new EventEmitter<string>();
  @Input() closeModalFunction: () => void;

 

  public formGroup: FormGroup;

  constructor(
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    if (this.cpxCards && this.cpxCards.length > 0) {
      this.formGroup = this._formBuilder.group({
        cards: [this.cpxCards[0]]
      });
    }
  }

  public onClose() {
    if (this.closeModalFunction) {
      this.closeModalFunction();
    }
  }

  public selectCardFnc(card: string): void {
    this.selectCard.emit(card);
  }

}
